import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import ViewFiles from "../documents/ViewFiles";
import { useSelector } from "react-redux";
const Whistleblowing = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [attributes] = useState([
    
    {
      type: "text",
      placeholder: "id",
      name: "ID",
      // tab: "details",
      validation: "",
      default: "",
      label: "id",
      required: false,
      view: true,
      tag: false,
      add: false,
      update: false,
    },
    {
      type: "datetime",
      placeholder: "selectDate",
      name: "updatedAt",
      // tab: "details",
      validation: "date",
      default: "empty",
      label: "submitted",
      required: false,
      view: false,
      tag: true,
      add: false,
      update: false,
      disabled: true
    },
    {
      type: "text",
      placeholder: "anonymity",
      name: "anonymity",
      validation: "",
      label: "anonymity",
      required: false,
      view: false,
      filter: false,
      tag: false,
      add: false,
      update: false,
      disabled: true
    },
    {
      type: "text",
      placeholder: "whistleblowerName",
      name: "whistleblowerName",
      label: "whistleblowerName",
      condition: { item: "anonymity", if: "confidential", then: "enabled", else: "disabled" },
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: false,
      update: false,
      disabled: true
    },
    {
      type: "text",
      placeholder: "whistleblowerMobileNumber",
      name: "whistleblowerMobileNumber",
      label: "whistleblowerMobileNumber",
      condition: { item: "anonymity", if: "confidential", then: "enabled", else: "disabled" },
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: false,
      update: false,
      disabled: true
    },
    {
      type: "text",
      placeholder: "whistleblowerEmail",
      name: "whistleblowerEmail",
      label: "whistleblowerEmail",
      condition: { item: "anonymity", if: "confidential", then: "enabled", else: "disabled" },
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: false,
      update: false,
      disabled: true
    },
    {
      type: "text",
      placeholder: "enterTopic",
      name: "title",
      // tab: "details",
      validation: "",
      default: "",
      label: "topic",
      required: true,
      view: true,
      add: true,
      update: false,
      disabled: true
    },
    {
      type: "multiSelect",
      placeholder: "select",
      name: "department",
      // tab: "details",
      validation: "",
      default: "",
      label: "department",
      showItem: "title",
      required: true,
      view: false,
      filter: true,
      tag: false,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "department/select",
      disabled: true
    },
    {
      type: "select",
      placeholder: "select",
      name: "category",
      // tab: "details",
      validation: "",
      default: "",
      label: "category",
      showItem: "locale",
      required: false,
      view: true,
      filter: true,
      tag: false,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "whistle-category/select",
      disabled: true
    },
    {
      type: "select",
      placeholder: "select",
      name: "level",
      // tab: "details",
      validation: "",
      default: "",
      label: "priority",
      required: false,
      view: true,
      filter: true,
      tag: false,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi:[
        {id: "low", value: t("low")},
        {id: "medium", value: t("medium")},
        {id: "high", value: t("high")}
      ]
    },
    {
      type: "select",
      placeholder: "status",
      // tab: "details",
      name: "status",
      validation: "",
      default: "",
      label: "status",
      required: true,
      view: false,
      tag: false,
      add: true,
      update: true,
      apiType:"JSON",
      selectApi:[
        {id: "new", value: t("new")},
        {id: "open", value: t("open")},
        {id: "in_progress", value: t("In progress")},
        {id: "close", value: t("close")},
      ]
    },
    {
        type: "datetime",
        placeholder: "selectDate",
        name: "updatedAt",
        // tab: "details",
        validation: "date",
        default: "empty",
        label: "submitted",
        required: false,
        view: true,
        tag: false,
        add: false,
        update: false,
        disabled: true
    },
    {
        type: "date",
        placeholder: "selectDate",
        name: "nextDeadline",
        // tab: "details",
        validation: "date",
        default: "empty",
        label: "nextDeadline",
        required: false,
        view: true,
        tag: false,
        add: true,
        update: true,
    },
    {
      type: "select",
      placeholder: "select",
      // tab: "details",
      name: "assignedCaseHandler",
      validation: "",
      default: "",
      showItem: "fullName",
      label: "Case handler",
      required: false,
      view: false,
      tag: false,
      add: false,
      update: true,
      apiType: "API",
      selectApi: "user/case-handler"
    },
    {
      type: "expired",
      placeholder: "status",
      // tab: "details",
      name: "status",
      validation: "",
      default: "",
      label: "status",
      required: false,
      view: true,
      tag: false,
      add: false,
      update: false,
    },
    {
      type: "textarea",
      placeholder: "description",
      name: "description",
      // tab: "details",
      validation: "",
      default: "",
      label: "description",
      required: true,
      view: false,
      tag: true,
      add: false,
      update: false,
      disabled: true
    },

  ]);

  const [advisorAttributes] = useState([
    
    {
      type: "text",
      placeholder: "id",
      name: "ID",
      // tab: "details",
      validation: "",
      default: "",
      label: "id",
      required: false,
      view: true,
      tag: false,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "company",
      name: "company",
      // tab: "details",
      validation: "",
      default: "",
      showItem: "organization",
      label: "company",
      required: false,
      view: true,
      tag: false,
      add: false,
      update: false,
      disabled: true
    },
    
    {
        type: "datetime",
        placeholder: "selectDate",
        name: "updatedAt",
        // tab: "details",
        validation: "date",
        default: "empty",
        label: "submitted",
        required: false,
        view: true,
        tag: false,
        add: false,
        update: false,
        disabled: true
    },
    {
        type: "date",
        placeholder: "selectDate",
        name: "nextDeadline",
        // tab: "details",
        validation: "date",
        default: "empty",
        label: "nextDeadline",
        required: false,
        view: true,
        tag: false,
        add: true,
        update: true,
    },
    {
      type: "expired",
      placeholder: "status",
      // tab: "details",
      name: "status",
      validation: "",
      default: "",
      label: "status",
      required: false,
      view: true,
      tag: false,
      add: false,
      update: false,
    },
    
  ]);
  
  const [viewFile, setViewFile] = useState(false);
  const [data, setData] = useState({});

  //to update the page title
  useEffect(() => {
    document.title = `${t("caseReports")} - Whistleblowing24`;
  }, [t]);

  const [actions] = useState([
      {
        element: "callback",
        type: "callback",
        id: "generatePdf",
        title: "generatePdf",
        icon: "Download",
        callback: (item, data) => {
          if(!data.file) return;
          setData({ item, data });
          setViewFile(true);
        },
      },
    ]);


  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable formView="normal" profileImage={false} bulkUplaod={true} {...props} api={`whistleblowing`} actions={actions} itemTitle={`title`} shortName={`caseReports`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={true} selectPrivilege={true} attributes={(props.user?.user?.authorisation==="advisor" && props.user?.user?.partner) ? advisorAttributes : attributes} cases={true} popUpUsingId={true} ></ListTable>
      {viewFile && <ViewFiles admin={true} customClass="large caseReports" page={data} onClose={() => setViewFile(false)} setLoaderBox={props.setLoaderBox} title={"attendanceToday"}></ViewFiles>}
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Whistleblowing);
